/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoStore {
    'use strict';

    class ExistingAdpPayrollController extends SaleItemTypeController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            '$q',
            '$translate',
            '$window',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "meevo.plugins.meevoStore.MeevoStoreService"
        ];

        public isInDev: boolean = true;

        public categoryList: any = [
            {
                id: 0,
                label: 'LABEL_ALL'
            },
            {
                id: 1,
                label: 'LABEL_MEEVOSTORE_INTEGRATIONS'
            },
        ];

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected $q: angular.IQService,
            protected $translate: angular.translate.ITranslateService,
            protected $window: angular.IWindowService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected storeService: Meevo.Plugins.MeevoStore.IMeevoStoreService,
        ) {
            super($scope,
                $rootScope,
                $state,
                $q,
                $translate,
                $window,
                appSettings,
                dataService,
                modalService,
                busyService,
                securityService,
                trackingService,
                storeService
            );
            this.itemList = [
                {
                    displayName: 'LABEL_MEEVOSTORE_HARDWARE_PERIPHERALS',
                    isPending: false,
                    salesForceId: null,
                    isTurnedOnForLocation: false,
                    bundled: false,
                    moduleId: null,
                    moduleTypeEnum: null,
                    price: 0,
                }
            ];
        }

    }
    angular.module('meevo.plugins.meevoStore')
        .controller('meevo.plugins.meevoStore.existingAdpPayrollController', ExistingAdpPayrollController);
}
